/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
// import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Toast, Modal } from 'antd-mobile';
import styles from './styles.module.less';
import { getCompanyProducts } from '../../service/chat-service';
import tools from '../../utils/tools';

import linkProduct from '../../public/images/link_product.png';

const propTypes = {
  onClose: PropTypes.func,
  liveInfo: PropTypes.shape({
    streamName: PropTypes.string,
    liveStart: PropTypes.string,
  }),
  shareUserId: PropTypes.string,
  liveId: PropTypes.number,
  history: PropTypes.arrayOf(PropTypes.string),
  videoHeight: PropTypes.number,
};

const defaultProps = {
  onClose: () => {},
  liveInfo: {},
  shareUserId: '',
  liveId: 0,
  videoHeight: 0,
  history: [],
};
class Index extends Component {
  constructor(props) {
    super(props);
    const {
      liveInfo, shareUserId, liveId, videoHeight,
    } = this.props;
    this.state = {
      liveInfo,
      shareUserId,
      liveId,
      list: [],
      videoHeight,
    };

    document.title = '商品列表';
  }

  componentDidMount() {
    this.getProductList();
  }

  /**
   * 关联商品价格回显
   * @param data
   * @returns {string|null}
   */
  renderPrice = (data) => {
    const isOpenAccount = data.templateType === 4;

    if (isOpenAccount) {
      // 开户模式
      return null;
    }
    switch (data.priceType) {
      case 1: {
        return '报价单';
      }
      case 2: {
        // 一口价
        return (
          <div>
            <span>
              ￥
              {tools.getMoney(data.price)}
            </span>
            <span className={styles.discount}>
              ￥
              {tools.getMoney(data.originalPrice)}
            </span>
          </div>
        );
      }
      case 3: {
        // 区间价
        return `￥${tools.getMoney(data.intervalPriceLeft)} - ￥${tools.getMoney(data.intervalPriceRight)}`;
      }
      case 4: {
        // 组合价
        return (
          <div>
            <span>
              ￥
              {tools.getMoney(data.specPrice)}
            </span>
            <span className={styles.discount}>
              ￥
              {tools.getMoney(data.specOriginalPrice)}
            </span>
          </div>
        );
      }
      default:
        return null;
    }
  }

  getProductList = async () => {
    const { liveInfo } = this.state;
    try {
      const { code, data, message } = await getCompanyProducts(liveInfo.extendId);
      if (code === 10000) {
        this.setState({ list: data.pageList });
      } else {
        Toast.show(message);
      }
    } catch (e) {
      Toast.show(e);
    }
  }

  handleToPage = (item) => {
    const { history } = this.props;
    const { liveId, streamName, shareUserId } = this.state;

    history.push(
      `/productDetail?productId=${item.id}&shareUserId=${shareUserId}&liveId=${liveId}&streamName=${streamName}`,
    );
  }

  renderProductList = () => {
    const { list } = this.state;
    return list.map((item) => (
      <div key={item.productName} style={{ marginBottom: 10 }} className={styles.list}>
        <div className={styles.jieshao}>
          <img
            style={{ width: '70px', height: '70px', marginRight: '20px' }}
            src={item.imgUrl || linkProduct}
            alt=""
          />
          <div>
            <div className={styles.name}>{item.productName}</div>
            <div className={styles.price} style={{ position: 'absolute', bottom: 0 }}>
              {this.renderPrice(item)}
            </div>
          </div>
        </div>
        <div className={styles.sfooter}>
          <span style={{ color: '#999999' }}>
            剩余
            {' '}
            <span style={{ color: 'rgb(255, 55, 55)' }}>
              {item.priceType === 4 ? item.specStockNum : item.stockNum}
            </span>
            {' '}
            件
          </span>
          <div className={styles.sale} onClick={this.handleToPage.bind(null, item)} role="button" tabIndex={0}>
            立即秒杀
          </div>
        </div>
      </div>
    ));
  }

  handleChangeClose = () => {
    const { onClose } = this.props;
    onClose();
  }

  render() {
    const { videoHeight } = this.state;
    return (
      <Modal
        popup
        visible
        animationType="slide-up"
        className={styles.modalContentRadius}
        maskClosable
        onClose={this.handleChangeClose}
      >
        <div className={styles.box} style={{ height: `calc(100vh - ${videoHeight}px)` }}>{this.renderProductList()}</div>
      </Modal>
    );
  }
}

Index.propTypes = propTypes;
Index.defaultProps = defaultProps;

export default withRouter(Index);
